import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import ReactPlaceholder from "react-placeholder";
import { RectShape } from "react-placeholder/lib/placeholders";
import { Config } from "services/common/config";

type Props = {
  height?: string | undefined;
  delay: number;
  ready?: boolean | undefined;
};

const StyledReactPlaceholder = styled(ReactPlaceholder)`
  position: relative;
  display: flex;
  flex-direction: column;
  height: ${(props: { height?: string | undefined }) =>
    props.height || "180px"} !important;
`;

const CenteredMessage = styled.div`
  position: absolute;
  width: 100%;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
`;

function Placeholder(props: Props): JSX.Element {
  const ref = useRef(false);
  const [customMessage, setCustomMessage] = useState<boolean>(false);

  useEffect(() => {
    ref.current = true;
    return () => {
      ref.current = false;
    };
  }, []);

  useEffect(() => {
    let intervalIndex: any;
    if (ref.current && !customMessage) {
      intervalIndex = setInterval(() => {
        setCustomMessage(true);
      }, Config.placeholder.timer);
    }

    return () => {
      if (!ref.current && intervalIndex !== undefined) {
        clearInterval(intervalIndex);
        setCustomMessage(false);
      }
    };
  }, [customMessage]);

  const customPlaceholder = (
    <div className="show-loading-animation">
      <RectShape color="lightgrey" />
      {customMessage && (
        <CenteredMessage>
          <FormattedMessage id="components.placeholder.customMessage" />
        </CenteredMessage>
      )}
    </div>
  );

  return (
    <StyledReactPlaceholder
      customPlaceholder={customPlaceholder}
      {...props}
      ready={props?.ready ?? false}
    >
      <div />
    </StyledReactPlaceholder>
  );
}

export default Placeholder;
